import { set } from "lodash";
import { ReactElement } from "react";
import { FieldValues } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";

import { FormType } from "../components";
import { flattenFormSchemaGroups, generateFieldDefaults, generateValidationSchema } from "../helpers";

import { FieldSchema } from "@/components/section";

export function useFormDefaults<TFormValues extends FieldValues, TRecord>(
  formSchema: FieldSchema<TFormValues, TRecord>[],
  formType: FormType = "create"
) {
  const validationSchema = {};
  const initialValues = {};
  const elements: Array<ReactElement> = [];

  const flattenedFormSchema = flattenFormSchemaGroups<TFormValues, TRecord>(formSchema);

  for (const fieldSchema of flattenedFormSchema) {
    const { initialValue, schema, element } = generateFieldDefaults<TFormValues, TRecord>(
      "name" in fieldSchema ? fieldSchema.name : uuidv4(),
      fieldSchema,
      formType
    );

    if ("name" in fieldSchema) {
      set(validationSchema, fieldSchema.name, schema);
      set(initialValues, fieldSchema.name, initialValue);
    }

    if (element) elements.push(element);
  }

  return {
    validationSchema: Yup.object().shape(generateValidationSchema(validationSchema)),
    initialValues: initialValues as TFormValues,
    elements,
  };
}
